import { LooseObjectType } from 'utils/globalTypes';

const ctpAllowedSources = ['primary', 'scheduled conversion'];

export function checkOfferHaveCtpAllowedSources(allowedSources: string[]) {
  return ctpAllowedSources.every((source) => allowedSources.includes(source));
}

export function getAvailableCtpPlan(offers: LooseObjectType[]) {
  const validCTPOffers = offers.reduce((acc, offer) => {
    if (
      checkOfferHaveCtpAllowedSources(
        offer?.offerChangeConfiguration?.allowedSources || [],
      )
    ) {
      acc.push(offer);
    }
    return acc;
  }, []);

  if (validCTPOffers.length === 1) {
    return {
      plan: {
        code: validCTPOffers[0].plan.code,
        name: validCTPOffers[0].plan.name,
      },
      offers: [validCTPOffers[0].offer],
    };
  }
  if (
    validCTPOffers.length === 2 &&
    validCTPOffers[0].plan.code === validCTPOffers[1].plan.code &&
    validCTPOffers[0].offer.subscriptionPlan.termLength !==
      validCTPOffers[1].offer.subscriptionPlan.termLength
  ) {
    const planOffers = [validCTPOffers[0].offer];
    if (
      validCTPOffers[0].offer.subscriptionPlan.termLength <
      validCTPOffers[1].offer.subscriptionPlan.termLength
    ) {
      planOffers.push(validCTPOffers[1].offer);
    } else {
      planOffers.unshift(validCTPOffers[1].offer);
    }
    return {
      plan: {
        code: validCTPOffers[0].plan.code,
        name: validCTPOffers[0].plan.name,
      },
      offers: planOffers,
    };
  }
  return null;
}
